function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4.397 8.09C9.672 1.916 18.379-.05 25.795 3.254c.84.374 1.219 1.36.844 2.2-.374.841-1.36 1.22-2.2.845C18.37 3.596 11.246 5.205 6.93 10.255c-4.316 5.05-4.797 12.337-1.181 17.91 3.616 5.573 10.466 8.104 16.836 6.22 6.37-1.883 10.744-7.732 10.747-14.375v-1.55c0-.92.747-1.666 1.667-1.666s1.667.746 1.667 1.666v1.551c-.005 8.12-5.35 15.269-13.135 17.57-7.786 2.303-16.16-.79-20.578-7.602-4.42-6.81-3.832-15.718 1.443-21.89zm31.091-4.258c.651-.65 1.706-.65 2.357 0 .651.65.651 1.706 0 2.357L19.512 24.522c-.65.651-1.706.651-2.357 0l-5-5c-.65-.65-.65-1.706 0-2.357.65-.65 1.706-.65 2.357 0l3.821 3.822z"
});

var SvgCheckCircle = function SvgCheckCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheckCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check-circle.d5d1f780.svg";
export { ForwardRef as ReactComponent };